// Which Persona inquiry verified each of a listing's documents, by document. The ids are kept in the
// listing's private data, which only its owner can read. Listings saved before that still hold them
// in public data until they are moved, so a listing with no private ids falls back to that copy.
const hasIds = ids => !!ids && typeof ids === 'object' && Object.keys(ids).length > 0;

export const documentInquiryIdsOf = listing => {
  const privateIds = listing?.attributes?.privateData?.documentInquiryIds;
  if (hasIds(privateIds)) return privateIds;
  const publicIds = listing?.attributes?.publicData?.documentInquiryIds;
  return hasIds(publicIds) ? publicIds : privateIds;
};
